import { BaseTreeProps } from 'business/models/CustomModels';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { LoadingDiv } from 'components/generic';
import NoDataFound from 'components/generic/noDataFound';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import React from 'react';
import Tree from 'react-virtualized-tree';

const folderNodeTypes = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.ProjectsFolder,
  ETreeNodeTypes.Projects,
  ETreeNodeTypes.Screens,
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.QuickAccess,
  ETreeNodeTypes.CrystalTrackv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.SearchesFolder,
  ETreeNodeTypes.RecycleBin,
];

const filterChildren = (node: any, expandedTreeNodeIds: Array<number>) => {
  if (!folderNodeTypes.includes(node.type)) {
    return;
  }

  if (folderNodeTypes.includes(node.type) && !node.children) {
    return node;
  }

  const filteredData =
    node.children?.map((_node) => filterChildren(_node, expandedTreeNodeIds)) || node;

  return {
    ...node,
    children: filteredData.filter((x) => x),
    state: { ...node.state, expanded: expandedTreeNodeIds.includes(node.id) },
  };
};

function BaseTree(props: BaseTreeProps) {
  const {
    generateNode,
    shouldRenderNode,
    mainHeight,
    treenodes,
    handleChange,
    expandedTreeNodeIds,
    backgroundColor,
    scrollToId,
    containerRef,
    isLoading,
    isSearchEnabled = false,
  } = props;

  const getContent = (node, rest) => {
    return generateNode(node, rest);
  };
  const nodesList = treenodes
    .map((node) =>
      shouldRenderNode
        ? shouldRenderNode(node)
        : filterChildren(node, expandedTreeNodeIds),
    )
    .filter((x) => x);
  const renderContent = (style, node, rest) => {
    return (
      <div
        id="basetree-node-content"
        style={{
          ...style,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: `calc(100% - ${style.marginLeft}px)`,
        }}
      >
        {getContent(node, rest)}
      </div>
    );
  };

  const getTreeContent = () => {
    if (isLoading) {
      return <LoadingDiv />;
    }
    if (treenodes.length < 1 && nodesList.length < 1) {
      return <NoDataFound />;
    }
    if (isSearchEnabled && treenodes.length && nodesList.length < 1) {
      return (
        <div className="flex h-full w-full flex-col justify-center items-center text-[#5D5D5D] text-xl">
          <RMSvgIcon name="NoResult" width="5rem" height="5rem" />
          Result Not Found
        </div>
      );
    }
    return (
      <Tree
        scrollToId={scrollToId}
        nodes={nodesList}
        onChange={handleChange}
        nodeMarginLeft={15}
      >
        {({ node, style, ...rest }) => renderContent(style, node, rest)}
      </Tree>
    );
  };

  return (
    <div
      id="basetree-mysidebar"
      className="sidebar"
      style={{ border: 'none' }}
      ref={containerRef}
    >
      <div
        className="vertical-nav"
        id="basetree-vertical-sidebar"
        style={{ height: mainHeight, backgroundColor: backgroundColor }}
      >
        {getTreeContent()}
      </div>
    </div>
  );
}

export default BaseTree;
